import { initializeApp } from "firebase/app";
// import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
 apiKey: "AIzaSyCwrWEqR7tmBjK7T0CixrXnQ2D708sezeQ",
  authDomain: "iwp-academy-demo.firebaseapp.com",
  projectId: "iwp-academy-demo",
  messagingSenderId: "204864654072",
  appId: "1:204864654072:web:d0a312655de31acbcfc90d",
};

export const firebaseApp = initializeApp(firebaseConfig);
